/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

document.querySelectorAll("[data-media-select]").forEach(element => {
    element.addEventListener("click", function() {
      let target_id = this.getAttribute("data-media-select");
      let target_pos = document.querySelector(`[data-media-id='${target_id}']`).offsetTop;
  
      window.scrollTo({
        top: target_pos - 100,
        behavior: "smooth"
      });
    });
  });

document.querySelectorAll('.collapsible-sections details').forEach((detail) => {
  detail.addEventListener('toggle', function() {
    if (this.open) {
      document.querySelectorAll('.collapsible-sections details').forEach((otherDetail) => {
        if (otherDetail !== this) {
          otherDetail.removeAttribute('open');
        }
      });
    }
  });
});
  
})();


